export default __webpack_public_path__ + "static/media/logo.9a1a1a4c.png";